<template>
  <div>
    <el-input @input="change" placeholder="Rate" v-model="rate" style="width:120px;"></el-input>
    <el-button v-if="saveIsActive" @click="saveNewRate" class="ml-3" type="success" icon="el-icon-check" circle size="mini"></el-button>
    <el-button v-if="saveIsActive" @click="returnToOriginal" class="ml-3" type="danger" icon="el-icon-close" circle size="mini"></el-button>
  </div>
</template>

<script>


export default {
  data() {
    return {
      rate: 0.00,
      originalRate: 0.00,
      saveIsActive: false
    }
  },
  beforeMount() {
    this.rate = this.params.data.rate
    this.originalRate = this.params.data.rate
  },
  methods: {
    ...$mapActions('voip-reseller-rate-api', {
      updateCustomerRate: 'update'
    }),
    returnToOriginal () {
      this.rate = this.originalRate
      this.saveIsActive = false
    },
    saveNewRate () {
      let data = {
        rate: this.rate
      }
      this.updateCustomerRate({data, id: this.params.data.id}).then(r => {
        this.originalRate = this.rate
        this.saveIsActive = false
      })
    },
    change(val) {
      if (this.originalRate !== this.rate) {
        this.saveIsActive = true
      } else {
        this.saveIsActive = false
      }

    }
  }
}
</script>
